/**
 * The view style's sizes on the Mac (docs/views.md#4-layouts): coast.css holds iPhone's and iPad's corners, spacing,
 * shared parts, and page margin as `--coast-<name>`, from design/tokens.json, and services/views/src/generated/sizes.json
 * the Mac's where they differ, such as its narrower margin and its shorter rows, which `bun run design:tokens` writes.
 */
import sizes from "../generated/sizes.json";

/**
 * What a page in the desktop layout starts with: the Mac's sizes on `:root:root`, which outranks the stock style's own
 * `:root` though this rule comes before it.
 */
export const MAC_SIZE_STYLE = `:root:root{${Object.entries(sizes.mac as Record<string, string>)
  .map(([name, value]) => `--coast-${name}:${value};`)
  .join("")}}`;
